import { i18n } from 'i18next';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setI18nInstance } from '../utils/i18n';

export const loadI18n = createAsyncThunk('LOAD_I18N', (i18nInstancePromise: Promise<i18n>) => {
  return i18nInstancePromise.then(setI18nInstance) as Promise<i18n>;
});
